import './style.css';

document.addEventListener('DOMContentLoaded', () => {
  // 1. Navigation Sticky Elevation & Active Scroll Spy
  const header = document.getElementById('header');
  const navLinks = document.querySelectorAll('.nav-link');
  const sections = document.querySelectorAll('section[id]');
  const mobileToggle = document.getElementById('mobile-toggle');
  const navList = document.getElementById('nav-links');

  // Mobile menu toggle
  if (mobileToggle && navList) {
    mobileToggle.addEventListener('click', () => {
      navList.classList.toggle('open');
    });

    // Close menu when clicking a link
    navLinks.forEach((link) => {
      link.addEventListener('click', () => {
        navList.classList.remove('open');
      });
    });
  }

  // Scroll listener for sticky header styling & scroll spy
  const handleScroll = () => {
    if (window.scrollY > 40) {
      header?.classList.add('scrolled');
    } else {
      header?.classList.remove('scrolled');
    }

    const scrollY = window.scrollY + 120;
    sections.forEach((section) => {
      const sectionTop = section.offsetTop;
      const sectionHeight = section.offsetHeight;
      const sectionId = section.getAttribute('id');

      if (scrollY >= sectionTop && scrollY < sectionTop + sectionHeight) {
        navLinks.forEach((link) => {
          if (link.getAttribute('href') === `#${sectionId}`) {
            link.classList.add('active');
          } else {
            link.classList.remove('active');
          }
        });
      }
    });
  };

  window.addEventListener('scroll', handleScroll, { passive: true });
  handleScroll();

  // 2. Lightbox Modal for Screenshots
  const galleryItems = document.querySelectorAll('.gallery-item');
  const lightboxModal = document.getElementById('lightbox-modal');
  const lightboxImg = document.getElementById('lightbox-img');
  const lightboxClose = document.getElementById('lightbox-close');

  if (lightboxModal && lightboxImg && lightboxClose) {
    galleryItems.forEach((item) => {
      item.addEventListener('click', () => {
        const fullUrl = item.getAttribute('data-full');
        if (fullUrl) {
          lightboxImg.src = fullUrl;
          lightboxModal.classList.add('active');
          lightboxModal.setAttribute('aria-hidden', 'false');
          document.body.style.overflow = 'hidden';
        }
      });
    });

    const closeLightbox = () => {
      lightboxModal.classList.remove('active');
      lightboxModal.setAttribute('aria-hidden', 'true');
      lightboxImg.src = '';
      document.body.style.overflow = '';
    };

    lightboxClose.addEventListener('click', closeLightbox);
    lightboxModal.addEventListener('click', (e) => {
      if (e.target === lightboxModal) {
        closeLightbox();
      }
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && lightboxModal.classList.contains('active')) {
        closeLightbox();
      }
    });
  }

  // 3. Skeleton Loaders for Media
  const initSkeletonLoaders = () => {
    // Hero Game Logo Skeleton
    const heroLogoImg = document.querySelector('.hero-game-logo');
    const heroLogoWrap = document.getElementById('hero-logo-wrap');
    if (heroLogoImg && heroLogoWrap) {
      const onHeroLogoDone = () => {
        heroLogoImg.classList.add('loaded');
        heroLogoWrap.classList.add('loaded');
      };
      if (heroLogoImg.complete && heroLogoImg.naturalHeight !== 0) {
        onHeroLogoDone();
      } else {
        heroLogoImg.addEventListener('load', onHeroLogoDone);
        heroLogoImg.addEventListener('error', onHeroLogoDone);
      }
    }

    // Gallery images
    const galleryImgs = document.querySelectorAll('.gallery-item img');
    galleryImgs.forEach((img) => {
      const parent = img.closest('.gallery-item');
      if (parent) {
        parent.classList.add('skeleton');
      }

      const onImageDone = () => {
        img.classList.add('loaded');
        parent?.classList.remove('skeleton');
      };

      if (img.complete && img.naturalHeight !== 0) {
        onImageDone();
      } else {
        img.addEventListener('load', onImageDone);
        img.addEventListener('error', () => {
          parent?.classList.remove('skeleton');
        });
      }
    });

    // Trailer Video Iframe
    const videoContainer = document.querySelector('.video-container');
    const videoIframe = document.querySelector('.video-container iframe');
    if (videoContainer && videoIframe) {
      videoContainer.classList.add('skeleton');
      
      const onIframeLoaded = () => {
        videoContainer.classList.remove('skeleton');
        videoIframe.classList.add('loaded');
      };

      videoIframe.addEventListener('load', onIframeLoaded);
      // Fallback timeout in case browser / sandbox restricts iframe load event
      setTimeout(onIframeLoaded, 2200);
    }
  };

  initSkeletonLoaders();

  // 4. Anti-scraping Email Protection (Decodes on client load)
  const initProtectedEmails = () => {
    const protectedEls = document.querySelectorAll('.email-protected');
    protectedEls.forEach((el) => {
      const user = el.getAttribute('data-user');
      const domain = el.getAttribute('data-domain');
      const subject = el.getAttribute('data-subject');
      if (user && domain) {
        const email = `${user}@${domain}`;
        const query = subject ? `?subject=${encodeURIComponent(subject)}` : '';
        el.href = `mailto:${email}${query}`;
      }
    });
  };

  initProtectedEmails();

  // 5. Atmospheric Particle Canvas (Gentle Snowflakes, Furnace Embers & Cosmic Dust)
  initAtmosphericCanvas();
});

function initAtmosphericCanvas() {
  const canvas = document.getElementById('ambient-canvas');
  if (!canvas) return;

  const ctx = canvas.getContext('2d');
  if (!ctx) return;

  let width = (canvas.width = window.innerWidth);
  let height = (canvas.height = window.innerHeight);

  const onResize = () => {
    width = canvas.width = window.innerWidth;
    height = canvas.height = window.innerHeight;
  };

  window.addEventListener('resize', onResize, { passive: true });

  // Limit particles for performance
  const particleCount = Math.min(Math.floor(window.innerWidth / 20), 45);
  const particles = [];

  class Particle {
    constructor() {
      this.reset(true);
    }

    reset(initial = false) {
      this.x = Math.random() * width;
      this.y = initial ? Math.random() * height : -10;
      const rand = Math.random();
      this.type = rand > 0.65 ? 'snow' : (rand > 0.3 ? 'ember' : 'star');

      if (this.type === 'snow') {
        this.size = Math.random() * 2 + 0.8;
        this.speedY = Math.random() * 0.6 + 0.25;
        this.speedX = Math.random() * 0.4 - 0.2;
        this.alpha = Math.random() * 0.35 + 0.15;
        this.color = `rgba(0, 168, 208, ${this.alpha})`;
      } else if (this.type === 'ember') {
        // Ember particle (rising from furnace)
        this.y = initial ? Math.random() * height : height + 10;
        this.size = Math.random() * 2.2 + 0.8;
        this.speedY = -(Math.random() * 0.7 + 0.25);
        this.speedX = Math.random() * 0.5 - 0.25;
        this.alpha = Math.random() * 0.45 + 0.2;
        this.color = `rgba(255, 0, 77, ${this.alpha})`;
      } else {
        // Subtle cosmic dust / space spark
        this.size = Math.random() * 1.5 + 0.5;
        this.speedY = (Math.random() - 0.5) * 0.2;
        this.speedX = (Math.random() - 0.5) * 0.2;
        this.alpha = Math.random() * 0.4 + 0.1;
        this.color = `rgba(215, 180, 255, ${this.alpha})`;
      }
    }

    update() {
      this.x += this.speedX;
      this.y += this.speedY;

      if (this.type === 'snow' && (this.y > height + 10 || this.x < -10 || this.x > width + 10)) {
        this.reset();
      } else if (this.type === 'ember' && (this.y < -10 || this.x < -10 || this.x > width + 10)) {
        this.reset();
      } else if (this.type === 'star' && (this.y < -10 || this.y > height + 10 || this.x < -10 || this.x > width + 10)) {
        this.reset();
      }
    }

    draw() {
      ctx.fillStyle = this.color;
      ctx.beginPath();
      ctx.arc(this.x, this.y, this.size, 0, Math.PI * 2);
      ctx.fill();
    }
  }

  for (let i = 0; i < particleCount; i++) {
    particles.push(new Particle());
  }

  let animationFrameId;
  const render = () => {
    ctx.clearRect(0, 0, width, height);
    particles.forEach((p) => {
      p.update();
      p.draw();
    });
    animationFrameId = requestAnimationFrame(render);
  };

  render();
}
